import { Dropdown, IconButton, IDropdownOption, IDropdownStyles, Label, Text } from '@fluentui/react';
import { RootState } from 'app/store';
import { textProp } from 'global/Application';
import { EHideReason } from 'global/Visibility/EHideReason';
import { IVisibilityScope } from 'global/Visibility/IVisibilityScope.type';
import * as IXrmTypes from 'model/CRM';
import * as FAM from 'model/FlexibleAttributeModel';
import React, { useMemo, useState } from 'react';

interface IProps {
    [key: string]: any;
    fieldValueOnChange?: (event: any, value: FAM.IEntityReferenceValue | null) => void;
    handleChange?: any;
    defaultFieldValue?: FAM.IReferenceValue;
    field?: FAM.IFlexibleField;
    config: FAM.IGroupConfigurationConfig;
    state?: RootState;
    visibility?: IVisibilityScope;
    disabled?: boolean;
    label?: string;
    placeholder?: string;
    defaultSelectedKey?: any;

}

export const getOptionsetItems = (config: FAM.IGroupConfigurationConfig, configRef: FAM.IRef, props: IProps) => {
    const optionSetId = config.cache.map_bcbs_config_attribute[configRef.id]._bcbs_config_optionsetid_value
    const scope = props.visibility;

    if (!optionSetId)
        return [];

    const options: IDropdownOption<IXrmTypes.bcbs_config_optionsetitem>[] = [];

    // todo move this to cache
    config.cache.map_bcbs_config_optionsetitems_bySetId[optionSetId]?.forEach(eachOption => {

        const attribute_effective_expirationDate = eachOption.bcbs_expirationdate
            ? new Date(eachOption.bcbs_expirationdate).getTime()
            : 0;

        const attribute_operative_effectiveDate = eachOption.bcbs_effectivedate
            ? new Date(eachOption.bcbs_effectivedate).getTime()
            : 0;


        const attribute_effective_ExpirationDate = eachOption.bcbs_expirationdate_effectivedate
            ? new Date(eachOption.bcbs_expirationdate_effectivedate).getTime()
            : 0;

        const attribute_effective_effectiveDate = eachOption.bcbs_effectivedate_effectivedate
            ? new Date(eachOption.bcbs_effectivedate_effectivedate).getTime()
            : 0;

        let visibility: EHideReason = 0;

        // // Effective Date
        if (scope?.effectiveDate && attribute_effective_effectiveDate > 0 && scope.effectiveDate > 0 && attribute_effective_effectiveDate > scope.effectiveDate)
            visibility = visibility | EHideReason.EffectiveDate;
        else if (scope?.operativeDate && attribute_operative_effectiveDate > 0 && scope.operativeDate > 0 && attribute_operative_effectiveDate > scope.operativeDate)
            visibility = visibility | EHideReason.EffectiveDate;
        else
            visibility = visibility & ~(EHideReason.EffectiveDate);

        // Expiration Date
        if (scope?.effectiveDate && attribute_effective_ExpirationDate > 0 && scope.effectiveDate > 0 && attribute_effective_ExpirationDate < scope.effectiveDate)
            visibility = visibility | EHideReason.ExpirationDate;
        else if (scope?.operativeDate && attribute_effective_expirationDate > 0 && scope.operativeDate > 0 && attribute_effective_expirationDate < scope.operativeDate)
            visibility = visibility | EHideReason.ExpirationDate;
        else
            visibility = visibility & ~(EHideReason.ExpirationDate);

        if (!scope?.product) {
            if (eachOption.bcbs_config_optionsetitemid === '17030507-a93d-ec11-8c61-00224803edb9') {
                visibility = visibility | EHideReason.Product;
            }
        }

        if (props.state?.status?.debug?.diagnosis)
            // for debugging purpose allow showing in admin mode
            options.push({
                id: eachOption.bcbs_config_optionsetitemid!,
                key: eachOption.bcbs_config_optionsetitemid!,
                text: `${eachOption.bcbs_name} [${eachOption.bcbs_value} / ${eachOption.bcbs_config_optionsetitemid}]`,
                disabled: visibility !== 0,
                data: eachOption
            });
        else
            if (visibility === 0)
                options.push({
                    id: eachOption.bcbs_config_optionsetitemid!,
                    key: eachOption.bcbs_config_optionsetitemid!,
                    text: eachOption.bcbs_name!,
                    data: eachOption
                });

    });

    return options;
}

// TODO rename this to OptionSetControl
const OptionsetControl: React.FunctionComponent<IProps> = (props) => {
    const [selectedKey, setSelectedKey] = useState(props.defaultFieldValue ? props.defaultFieldValue.id : props.defaultSelectedKey ?? props.defaultValue);

    const options = useMemo(() => {
        if (props.field)
            return getOptionsetItems(props.config, props.field.configRef, props);

        console.warn('Option set for the field not found!', props.field);

        return null;
    }, []);

    const style = useMemo(() => {

        const dropdownStyles: Partial<IDropdownStyles> = {
            dropdownOptionText: { overflow: 'visible', whiteSpace: 'normal' },
            dropdownItem: { height: 'auto', },
        };

        return { dropdownStyles };
    }, [])


    const fieldValueOnChange = (event: React.FormEvent<HTMLDivElement> | null, option?: IDropdownOption<IXrmTypes.bcbs_config_optionsetitem> | null, index?: number | undefined) => {
        if (option) {
            const value: FAM.IEntityReferenceValue = {
                type: 'entity',
                entityType: 'bcbs_config_optionsetitem',
                id: option.data!.bcbs_config_optionsetitemid!,
                name: option.data!.bcbs_name!,
            }
            props.fieldValueOnChange?.(event, value);
            setSelectedKey(option.key);
        } else {
            props.fieldValueOnChange?.(event, null);
            setSelectedKey(null);
        }
    }

    if (props.disabled)
        return <div style={textProp.root.style}>
            <Label styles={textProp.label}>{props.label}</Label>
            <Text styles={textProp.textStyles}>{props.defaultFieldValue?.name ?? '---'}</Text>
        </div>;

    return (
        <Dropdown
            placeholder={props.placeholder}
            label={props.label}
            options={options ?? []}
            styles={style.dropdownStyles}
            disabled={props.disabled}
            title={props.defaultFieldValue?.name}
            onRenderCaretDown={(scopeProps, defaultRender) => {
                const defaultRenderElement = defaultRender?.(scopeProps);

                return <>
                    {/* <Stack horizontal verticalAlign={"center"}></Stack> */}
                    <IconButton
                        iconProps={{ iconName: 'Clear', styles: { root: { fontSize: 'x-small', padding: '5px' } } }}
                        styles={{ root: { height: '100%', } }}
                        onClick={(event) => {
                            event.stopPropagation();
                            fieldValueOnChange(null, null);

                        }}
                    />
                    {/* <Icon
                        iconName={"ChevronDown"}
                        styles={{
                            root: {
                                color: "rgb(96, 94, 92)",
                                "&:hover": {
                                    fontWeight: 800
                                }
                            }
                        }}
                        onClick={(event) => event?.currentTarget?.parentNode?.onClick!}
                    /> */}
                    {defaultRenderElement}
                </>;

            }}
            //@ts-ignore
            // defaultSelectedKey={props.defaultFieldValue ? props.defaultFieldValue.id : props.defaultSelectedKey ?? props.defaultValue}
            selectedKey={selectedKey}
            onChange={fieldValueOnChange}
            multiSelect={props.multiSelect}
            {...props.other}
        />
    );
}

export default OptionsetControl;